import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderSummary } from "../store/order-slice";
import DashboardCards from "../components/dashboard/DashboardCards";
import DashboardChat from "../components/dashboard/DashboardChat";
import { Role, RoleSign, Scope } from "../enums/enums";
import SubHeader from "../components/header/SubHeader";
import { getCardsData, getRestaurantCardsData } from "../models/dashboardModel";
import { fetchAllContact } from "../store/contact-slice";

const Dashboard = () => {
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        orderSummary,
        fetchOrderSummaryStatus,
        error
    } = useSelector((state) => state.order);

    const { items: conatctUs } = useSelector((state) => state.contact);

    const getCardDataByRole = (userRole, orderSummary) => {
        if (
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner) &&
            userRole?.scope === Scope.Branch
        ) {
            return getCardsData(orderSummary);
        }
        if (
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner) &&
            userRole?.scope === Scope.Restaurbant
        ) {
            return getRestaurantCardsData(orderSummary, conatctUs.length);
        }
        return [];
    };

    useEffect(() => {
        if (userRole) {
            dispatch(fetchOrderSummary(userRole));
        }
        if ((userRole?.scope === Scope.Restaurant &&
            (userRole?.role === Role.Admin || userRole?.role === Role.Owner))) {
            dispatch(fetchAllContact())
        }
    }, [dispatch, userRole]);

    const cardData = getCardDataByRole(userRole, orderSummary);
    return (
        <>
            {/* Branch-level dashboard for Admin/Owner */}
            {(userRole?.scope === Scope.Branch &&
                (userRole?.role === Role.Admin || userRole?.role === Role.Owner)) && (
                    <div className="container p-0 ms-0">
                        {fetchOrderSummaryStatus === "loading" && <p>Loading...</p>}
                        {fetchOrderSummaryStatus === "failed" && (
                            <h6 className="text-danger">{error}</h6>
                        )}
                        {fetchOrderSummaryStatus === "success" && (
                            <>
                                <DashboardCards data={cardData} />
                                <DashboardChat data={orderSummary?.last30Days} />
                            </>
                        )}
                    </div>
                )}

            {/* Restaurant-level dashboard for Admin/Owner */}
            {(userRole?.scope === Scope.Restaurant &&
                (userRole?.role === Role.Admin || userRole?.role === Role.Owner)) && (
                    <div className="container p-0 ms-0">
                        {fetchOrderSummaryStatus === "loading" && <p>Loading...</p>}
                        {fetchOrderSummaryStatus === "failed" && (
                            <h6 className="text-danger">{error}</h6>
                        )}
                        {fetchOrderSummaryStatus === "success" && (
                            <DashboardCards data={cardData} />
                        )}
                    </div>
                )}

            {/* Default dashboard for all other roles */}
            {(userRole?.roleSign !== RoleSign.Admin && userRole?.roleSign !== RoleSign.Owner)
                && (
                    <div className="container p-0 ms-0">
                        <SubHeader title="Dashboard" />
                    </div>
                )}
        </>
    );
}
export default Dashboard;
